@if (dialogData.readonlyOther) {
  <cue-modal data-cy="assist-reservation-detail" [modal]="modal" class="notch-fix">
    <cue-modal-header
      [emitClose]="dialogData.allowCompact || modal === null || modal === undefined"
      (headerClose)="closeDialog()"
      [title]="dialogData.reservation.resourceAttendees[0].resource.name"
      [tabsVisible]="true"
      class="desktop-tabs"
      [selectedTab]="activeTab()"
      (tabClick)="changeTab($event)"
      [tabs]="[translation.reservationPopup.reservation | transloco, translation.reservationPopup.detail | transloco]"
    />
    <cue-modal-body>
      <div class="modal-body">
        <div class="modal-body-inner">
          @if (activeTab() === 0) {
            <div class="row">
              <div class="col col-md-12">
                <div class="align-center">
                  <cue-icon [icon]="ICONS.cueExclamationCircle" />
                </div>
                <h2 class="other">
                  {{ translation.reservationPopup.other | transloco }}
                </h2>
              </div>
            </div>
          }
          @if (activeTab() === 1) {
            <assist-reservation-detail-resource-tab
              [eventStart]="start()"
              [resourceAttendees]="dialogData.reservation.resourceAttendees"
            />
          }
        </div>
      </div>
    </cue-modal-body>
    <cue-modal-footer>
      @if (uiState() !== 'loading') {
        <cue-button
          data-cy="assist-reservation-detail-close"
          [icon]="ICONS.cueClose"
          (click)="closeDialog()"
          [smallResponsive]="true"
        >
          {{ translation.reservationPopup.close | transloco }}
        </cue-button>
      }
    </cue-modal-footer>
  </cue-modal>
}
@if (!dialogData.readonlyOther) {
  <cue-modal data-cy="assist-reservation-detail" [modal]="modal" class="notch-fix" [formGroup]="editForm">
    <cue-modal-header
      [selectedTab]="activeTab()"
      [emitClose]="dialogData.allowCompact || modal === null || modal === undefined"
      (headerClose)="closeDialog()"
      [title]="modalTitle()"
      [tabsVisible]="true"
      class="desktop-tabs"
      [tabs]="tabs"
      (tabClick)="changeTab($event)"
    />
    <cue-modal-body>
      <div class="modal-body">
        @if (uiState() === 'loading') {
          <cue-loading />
        }

        @if (uiState() !== 'loading') {
          <div class="modal-body-inner">
            @if (activeTab() === 0) {
              <div class="calendar-scroller" [class.readonly]="uiState() === 'view'">
                <div class="hide-scrollbar">
                  <ng-template #eventTemplate let-event="weekEvent">
                    @if (event.event?.resizable?.beforeStart && !event.startsBeforeDay) {
                      <img
                        [style]="{
                          borderRadius: '5px 5px 0 0',
                          backgroundColor: availability().eventAvailability | availabilityColor,
                        }"
                        src="assets/icons/drag-handle.svg"
                        class="drag-handle-icon drag-handle-icon-before"
                      />
                    }

                    <!--      PROSIM NECH MI TAM TEN id=EVENT NA SCROLL INTO VIEW-->
                    <div
                      class="cal-event my-cal-event"
                      id="event"
                      [style]="{
                        borderColor:
                          uiState() === 'view'
                            ? 'var(--assist-color_common_main)'
                            : (availability().eventAvailability | availabilityColor),
                      }"
                    >
                      <div
                        class="cal-event-background"
                        [style]="{
                          background:
                            uiState() === 'view'
                              ? 'transparent'
                              : (availability().eventAvailability | availabilityColor),
                        }"
                      ></div>
                    </div>
                    @if (event.event?.resizable?.afterEnd && !event.endsAfterDay) {
                      <img
                        #endResize
                        [style]="{
                          borderRadius: '0 0 5px 5px',
                          backgroundColor: availability().eventAvailability | availabilityColor,
                        }"
                        src="assets/icons/drag-handle.svg"
                        class="drag-handle-icon drag-handle-icon-after"
                      />
                    }
                  </ng-template>

                  <ng-template #markerTemplate />

                  <ng-template
                    #hourTemplate
                    let-segment="segment"
                    let-locale="locale"
                    let-segmentHeight="segmentHeight"
                    let-isTimeLabel="isTimeLabel"
                    let-daysInWeek="daysInWeek"
                  >
                    <div
                      class="cal-hour-segment"
                      [style.height.px]="segmentHeight"
                      [class.cal-hour-start]="segment.isStart"
                      [class.cal-after-hour-start]="!segment.isStart"
                      [ngClass]="segment.cssClass"
                    >
                      <div
                        class="bg"
                        [style]="{
                          width: '10px',
                          height: segmentHeight + 'px',
                          marginBottom: '2px',
                          display: 'inline-block',
                          background:
                            getAvailability(
                              availability().availabilityView,
                              segment.date,
                              minimum(),
                              uiState(),
                              dialogData.reservation
                            ) | availabilityColor,
                        }"
                      ></div>

                      @if (isTimeLabel) {
                        <div class="cal-time">
                          {{
                            segment.displayDate
                              | calendarDate: (daysInWeek === 1 ? 'dayViewHour' : 'weekViewHour') : locale
                          }}
                        </div>
                      }
                    </div>
                  </ng-template>
                  <mwl-calendar-day-view
                    (eventTimesChanged)="eventTimesChanged($event)"
                    [currentTimeMarkerTemplate]="markerTemplate"
                    class="super-calendar"
                    [minimumEventHeight]="15"
                    [hourSegmentTemplate]="hourTemplate"
                    [eventTemplate]="eventTemplate"
                    [hourSegmentHeight]="30"
                    [events]="calendarComponentEvents()"
                    [hourSegments]="4"
                    [viewDate]="viewDate()"
                  />
                </div>
                <div class="calendar-date">
                  @if (showPage()) {
                    @if (previousPageAvailable()) {
                      <cue-icon
                        class="arrow arrow-left"
                        [icon]="ICONS.cueCaretLeftFill"
                        (click)="previousPageAvailable() ? decrementPage() : 0"
                      />
                    }
                  }

                  <p>{{ viewDate() | date: 'shortDate' }}</p>
                  @if (showPage()) {
                    @if (nextPageAvailable()) {
                      <cue-icon
                        class="arrow arrow-right"
                        [icon]="ICONS.cueCaretRightFill"
                        (click)="nextPageAvailable() ? incrementPage() : 0"
                      />
                    }
                  }
                </div>
              </div>

              <div class="reservation-content">
                <div class="row">
                  <div class="col-md-12">
                    @if (uiState() === 'view') {
                      @if (isAllDay()) {
                        <div class="inner allday">
                          <span class="start">
                            {{ translation.reservationPopup.allDay | transloco }}
                          </span>
                          {{ this.start() | dateFormat }}
                        </div>
                      } @else {
                        <cue-datetime-info
                          [dateTime]="currentEvent().start"
                          [type]="'from'"
                          [isStart]="true"
                          class="startEnd"
                        />
                        <cue-datetime-info
                          [dateTime]="currentEvent().end"
                          [type]="'to'"
                          [isStart]="false"
                          class="startEnd"
                        />
                      }
                    }

                    @if (uiState() === 'edit') {
                      @if (showAllDay()) {
                        <div class="all-day-group">
                          <label>{{ translation.reservationPopup.allDay | transloco }}</label>
                          <assist-checkbox [formControl]="allDayControl" />
                        </div>
                      }
                      <div class="date-time-separate-info-wrapper">
                        <div class="inner">
                          <p class="item-label start">
                            {{ translation.reservationPopup.start | transloco }}
                          </p>
                          <cue-date-time-separate-info
                            [dateOnly]="isAllDay()"
                            (edited)="onChanged($event, true)"
                            [editable]="true"
                            [dateTime]="currentEvent().start"
                            [type]="'from'"
                            [isStart]="true"
                            class="startEnd"
                          />
                        </div>
                        <div class="dots">
                          <div class="group">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                          </div>
                          <div class="group">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                          </div>
                        </div>
                        <div class="inner">
                          <p class="item-label end">
                            {{ translation.reservationPopup.end | transloco }}
                          </p>
                          <cue-date-time-separate-info
                            #endPicker
                            [dateOnly]="isAllDay()"
                            [min]="currentEvent().start"
                            (edited)="onChanged($event, false)"
                            [editable]="true"
                            [dateTime]="currentEvent().end"
                            [type]="'to'"
                            [isStart]="false"
                            class="startEnd"
                          />
                        </div>
                      </div>
                    }

                    <div class="line" style="margin: 16px 0"></div>
                  </div>
                </div>
                <div class="reservation-scrollable" [class.in-edit]="uiState() === 'edit'">
                  @if (repetitiveEventsEnabled() || dialogData.reservation.type !== 'singleInstance') {
                    <div class="repetition-section">
                      @if (mode() !== 'new' && dialogData.reservation.type !== 'singleInstance') {
                        <div class="repetition-header">
                          <p class="item-label">{{ translation.reservationPopup.eventType | transloco }}</p>
                          <span class="repetition-badge">{{ recurrenceTypeLabel() }}</span>
                        </div>
                      }

                      @if (recurrenceSummary()) {
                        <p class="repetition-summary">{{ recurrenceSummary() }}</p>
                      }

                      @if (repetitiveEventsEnabled() && uiState() === 'edit' && supportsSeriesScopeSwitch()) {
                        <div class="edit-scope-switch">
                          <span>{{ translation.reservationPopup.editWholeSeries | transloco }}</span>
                          <kendo-switch [formControl]="$any(editForm.get('editWholeSeries'))" />
                        </div>
                      }

                      @if (uiState() === 'edit' && canEditRecurrencePattern()) {
                        <div class="recurrence-editor-wrapper">
                          <assist-recurrence-editor
                            [start]="start()"
                            [maxEndDate]="recurrenceEndDateMax()"
                            [supportedPatternTypes]="repetitiveEventOptions().supportedPatternTypes"
                            [formControl]="$any(editForm.get('recurrence'))"
                          />
                        </div>
                      }
                    </div>
                    <div class="line" style="margin: 16px 0"></div>
                  }
                  <div class="row reservation-name">
                    <div class="col-md-12">
                      <div class="name-cont">
                        <p class="item-label">
                          {{ translation.reservationPopup.name | transloco }}
                        </p>
                        <div class="value">
                          @if (uiState() === 'view') {
                            {{ dialogData.reservation.subject | subjectPipe }}
                          }

                          @if (uiState() === 'edit') {
                            <div class="input-group">
                              <assist-textbox
                                data-cy="assist-reservation-detail-subject"
                                [formControl]="$any(editForm.get('subject'))"
                                [showClear]="true"
                                id="subject"
                                name="subject"
                              />
                              <!--                                                            <input-->
                              <!--                                                                cueRtl-->
                              <!--                                                                -->
                              <!--                                                                id="subject"-->
                              <!--                                                                class="form-control"-->
                              <!--                                                                name="subject"-->
                              <!--                                                                type="text"-->
                              <!--                                                                [cueClearable]="true"-->
                              <!--                                                                #subject-->
                              <!--                                                            />-->
                            </div>
                            @if (uiState() === 'edit') {
                              <p class="placeholders-info descriptionText">
                                {{ translation.common.placeholders | transloco }}
                              </p>
                            }
                          }
                        </div>
                      </div>
                      <div class="line"></div>
                    </div>
                  </div>

                  <div class="reservation-content-inner">
                    <div class="row">
                      <div class="col-md-12">
                        <p class="item-label">
                          {{ translation.reservationPopup.location | transloco }}
                        </p>

                        @for (resourceAttendee of dialogData.reservation.resourceAttendees; track $index) {
                          @let resourceSchedulingRules =
                            getSchedulingRulesForDisplay(resourceAttendee.resource.schedulingSettings);
                          <div class="flex flex-row gap-2 items-center justify-between location-row-header">
                            <div class="location-name-with-rules">
                              <span>{{
                                (resourceAttendee.resource.displayNameForApp | localizedString) ??
                                  (resourceAttendee.resource.displayName | localizedString)
                              }}</span>
                              @if (resourceSchedulingRules.length > 0) {
                                <ng-template #resourceSchedulingRulesTemplate>
                                  <div class="resource-scheduling-rules-tooltip">
                                    @for (rule of resourceSchedulingRules; track rule) {
                                      <p class="resource-scheduling-rules-tooltip__rule">
                                        {{ rule }}
                                      </p>
                                    }
                                  </div>
                                </ng-template>
                                <span
                                  class="repetition-badge reservation-rules-badge"
                                  cueTooltipCommonType="info"
                                  [cueTooltip]="resourceSchedulingRulesTemplate"
                                  cueTooltipPanelClass="reservation-rules-tooltip-panel"
                                >
                                  {{ translation.reservationPopup.bookingRulesLabel | transloco }}
                                </span>
                              }
                            </div>
                            @if (mode() !== 'new' && !dialogData.reservation.cancelled) {
                              <div class="state" [ngClass]="getTextKeyAndClass(resourceAttendee)[1]">
                                <p>{{ getTextKeyAndClass(resourceAttendee)[0] | transloco }}</p>
                              </div>
                            }
                          </div>

                          @if (
                            resourceAttendee.statusesByDay.length > 2 && dialogData.reservation.start.utcDateTime < now
                          ) {
                            <kendo-expansionpanel
                              class="show-panel"
                              expandIcon="k-icon k-font-icon k-i-plus"
                              collapseIcon="fa fa-minus"
                              [title]="getExpandeTitle(resourceAttendee, resourceAttendee.resource | resourceTitle)"
                            >
                              @for (
                                text of getExpanderTexts(resourceAttendee, resourceAttendee.resource | resourceTitle);
                                track $index
                              ) {
                                <div>{{ text }}</div>
                              }
                            </kendo-expansionpanel>
                          } @else {
                            @if (resourceAttendee.status === 'confirmed') {
                              <p class="info-label confirmed">
                                {{
                                  translation.reservations.confirmed
                                    | transloco
                                      : {
                                          when: (resourceAttendee.confirmedWhen | dateTimeFormat),
                                          who: resourceAttendee.confirmedBy,
                                        }
                                }}
                              </p>
                            } @else {
                              @if (resourceAttendee.confirmAvailable) {
                                <p class="warning-label">
                                  {{
                                    translation.reservations.confirmationRequiredUntil
                                      | transloco
                                        : {
                                            until: confirmTo(resourceAttendee),
                                            resourceName: resourceAttendee.resource | resourceTitle,
                                          }
                                  }}
                                </p>
                              } @else if (resourceAttendee.status === 'need-confirmation') {
                                <p class="need-confirmation-label">
                                  {{
                                    getTextKeyForConfirmation(resourceAttendee)
                                      | transloco
                                        : {
                                            from: confirmFrom(resourceAttendee),
                                            to: confirmTo(resourceAttendee),
                                            resourceName: resourceAttendee.resource | resourceTitle,
                                          }
                                  }}
                                </p>
                              }
                            }
                          }

                          <assist-attendees-dropdown-item
                            [preferAttendeeCalendar]="true"
                            [iCalUid]="dialogData.reservation?.iCalUId"
                            [currentEventLowerBound]="dialogData.reservation?.start.utcDateTime"
                            [currentEventUpperBound]="dialogData.reservation?.end.utcDateTime"
                            [displayInfo]="false"
                            [from]="start()"
                            [to]="end()"
                            [lowerBound]="minimum()"
                            [upperBound]="maximum()"
                            [name]="resourceAttendee.resource.displayName | localizedString"
                            [email]="resourceAttendee.resource.email"
                          />
                          @if (configService.value.navigationEnabled && resourceAttendee.resource.navigationEnabled) {
                            <div class="navigate-button" (click)="onNavigate(resourceAttendee)">
                              <p>
                                <cue-icon [icon]="ICONS.cueDirections" />
                                {{ translation.reservations.navigateTo | transloco }}
                              </p>
                            </div>
                          }

                          <div class="line"></div>
                        }
                      </div>
                    </div>

                    @if (anyPremiumResourceLikeInAttendees()) {
                      <div class="row">
                        @if (uiState() === 'edit' || originalRequiredAttendees().length > 0) {
                          <div class="col-12">
                            <p class="item-label">
                              {{ translation.reservationPopup.requiredAttendees | transloco }}
                            </p>
                            <div class="attendees-cont">
                              @if (uiState() === 'view') {
                                @for (attendee of originalRequiredAttendees(); track attendee) {
                                  <div class="attendee-card">
                                    <div class="attendee-ico" [ngStyle]="{ 'background-color': attendee.color }">
                                      <span class="initials">
                                        {{ attendee.initials }}
                                      </span>
                                    </div>
                                    <div class="attendee-text">{{ attendee.name }} ({{ attendee.email }})</div>
                                  </div>
                                }
                              }

                              @if (uiState() === 'edit') {
                                @if (!currentUserPack().loading && !currentUserInAttendees()) {
                                  <div>
                                    <button class="add-me-button" (click)="addMeToAttendees()">
                                      {{ translation.reservationPopup.addMeToReservation | transloco }}
                                    </button>
                                  </div>
                                }
                                <assist-attendees-dropdown
                                  [from]="start()"
                                  [to]="end()"
                                  [preferEmail]="true"
                                  [lowerBound]="minimum()"
                                  [upperBound]="maximum()"
                                  [value]="requiredAttendeesDropdownData()"
                                  (valueChange)="onAttendeeValueChange($event, 'required')"
                                />
                              }
                            </div>
                          </div>
                        }

                        @if (uiState() === 'edit' || originalOptionalAttendees().length > 0) {
                          <div class="col-12">
                            <p class="item-label">
                              {{ translation.reservationPopup.optionalAttendees | transloco }}
                            </p>
                            <div class="attendees-cont">
                              @if (uiState() === 'view') {
                                @for (attendee of originalOptionalAttendees(); track attendee) {
                                  <div class="attendee-card">
                                    <div class="attendee-ico" [ngStyle]="{ 'background-color': attendee.color }">
                                      <span class="initials">
                                        {{ attendee.initials }}
                                      </span>
                                    </div>
                                    <div class="attendee-text">{{ attendee.name }} ({{ attendee.email }})</div>
                                  </div>
                                }
                              }
                              @if (uiState() === 'edit') {
                                <assist-attendees-dropdown
                                  [preferEmail]="true"
                                  [from]="start()"
                                  [to]="end()"
                                  [lowerBound]="minimum()"
                                  [upperBound]="maximum()"
                                  [value]="optionalAttendeesDropdownData()"
                                  (valueChange)="onAttendeeValueChange($event, 'optional')"
                                />
                              }
                            </div>

                            <div class="line"></div>
                          </div>
                        }
                        @if (dialogData.reservation.organizer) {
                          <div class="col-12">
                            <div class="row">
                              <div class="col-12">
                                <p class="item-label">
                                  {{ translation.reservationPopup.organizer | transloco }}
                                </p>
                                @if (dialogData.reservation.organizer.emailAddress?.name) {
                                  <span>
                                    {{ dialogData.reservation.organizer.emailAddress?.name }}
                                    ({{ dialogData.reservation.organizer.emailAddress?.address }}
                                    )
                                  </span>
                                } @else {
                                  <span>{{ dialogData.reservation.organizer.emailAddress?.address }}</span>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @let onlineMeeting = onlineMeetingLink();
                    @if (onlineMeeting || (anyPremiumResourceLikeInAttendees() && anyOnlineMeetingAvailable())) {
                      @if (
                        onlineMeeting ||
                        (uiState() === 'edit' &&
                          (!dialogData.reservation.iCalUId || !configService.isTouchoneCalendar()))
                      ) {
                        <div class="row" data-cy="assist-reservation-online-meeting">
                          <div class="col-md-12">
                            <p class="item-label">
                              {{ translation.reservationPopup.onlineMeeting | transloco }}
                            </p>

                            @if (onlineMeeting) {
                              <a
                                data-cy="assist-reservation-online-link"
                                [href]="onlineMeeting.url"
                                target="_blank"
                                rel="noreferrer noopener"
                                >{{ onlineMeeting.label }}</a
                              >
                            }
                            @if (
                              uiState() === 'edit' && anyPremiumResourceLikeInAttendees() && anyOnlineMeetingAvailable()
                            ) {
                              @if (!dialogData.reservation.iCalUId) {
                                @if (configService.value.webexEnabled) {
                                  <div class="connection">
                                    <div class="image-label-wrapper">
                                      <img src="assets/images/webex-logo.svg" />
                                      <p class="descriptionText">Webex</p>
                                    </div>
                                    @if (webexPaired().loading) {
                                      <cue-loading />
                                    }
                                    @if (!webexPaired().loading) {
                                      @if (!webexPaired().data!.paired) {
                                        <p class="descriptionText">
                                          {{ translation.webex.notPaired | transloco }}
                                        </p>
                                      }
                                      @if (webexPaired().data!.paired) {
                                        <kendo-switch
                                          offLabel=" "
                                          onLabel=" "
                                          class="form-control"
                                          [formControl]="$any(editForm.get('webex'))"
                                        />
                                      }
                                    }
                                  </div>
                                }
                              }
                              @if (!configService.isTouchoneCalendar()) {
                                <div class="connection">
                                  <div class="image-label-wrapper">
                                    <p class="descriptionText">
                                      {{ configService.isGspace() ? 'Hangouts Meet' : 'Microsoft Teams' }}
                                    </p>
                                  </div>
                                  @if (configService.isO365()) {
                                    <kendo-switch
                                      offLabel=" "
                                      onLabel=" "
                                      class="form-control"
                                      [formControl]="$any(editForm.get('teams'))"
                                    />
                                  }
                                  @if (configService.isGspace()) {
                                    <kendo-switch
                                      offLabel=" "
                                      onLabel=" "
                                      class="form-control"
                                      [formControl]="$any(editForm.get('meet'))"
                                    />
                                  }
                                </div>
                              }
                            }
                          </div>
                        </div>
                      }
                    }
                    @if (configService.isTouchoneCalendar()) {
                      <div class="row">
                        <div class="col-md-12">
                          <p class="item-label">
                            {{ translation.reservationPopup.visibility.title | transloco }}
                          </p>
                          <div class="flex-inline">
                            @if (uiState() === 'view') {
                              <div class="descriptionText">
                                {{
                                  (dialogData.reservation.visibility === 'private'
                                    ? translation.reservationPopup.visibility.private
                                    : translation.reservationPopup.visibility.public
                                  ) | transloco
                                }}
                              </div>
                            }
                            @if (uiState() === 'edit') {
                              <div class="kendo-switch-wrapper">
                                <assist-dropdownlist
                                  [data]="visibilities"
                                  [formControl]="$any(editForm.get('visibility'))"
                                  valueField="value"
                                  textField="text"
                                  [popupSettings]="{
                                    appendTo: 'component',
                                  }"
                                >
                                  <ng-template itemTemplate let-dataItem>
                                    {{ dataItem?.text | transloco }}
                                  </ng-template>
                                  <ng-template valueTemplate let-dataItem>
                                    {{ dataItem?.text | transloco }}
                                  </ng-template>
                                </assist-dropdownlist>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }

                    <div class="row">
                      <div class="col-md-12">
                        <p class="item-label">
                          {{ translation.reservationPopup.eventShow | transloco }}
                        </p>
                        <div class="flex-inline">
                          <div class="kendo-switch-wrapper">
                            @if (uiState() === 'view') {
                              {{ dialogData.reservation.showAs.key | transloco }}
                            }

                            @if (uiState() === 'edit') {
                              <assist-dropdownlist
                                [popupSettings]="{
                                  appendTo: 'component',
                                  popupClass: '.zfix',
                                }"
                                [data]="showAsMap[configService.getMode()]"
                                [formControl]="editForm.controls.showAs"
                                valueField="value"
                                textField="key"
                              >
                                <ng-template itemTemplate let-dataItem>
                                  {{ dataItem?.key | transloco }}
                                </ng-template>
                                <ng-template valueTemplate let-dataItem>
                                  {{ dataItem?.key | transloco }}
                                </ng-template>
                              </assist-dropdownlist>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <p class="item-label">
                          {{ translation.reservationPopup.reminder.title | transloco }}
                        </p>
                        <div class="flex-inline">
                          <div class="kendo-switch-wrapper">
                            @if (uiState() === 'view') {
                              {{ editForm.controls.reminder.value.text }}
                            }

                            @if (uiState() === 'edit') {
                              <assist-dropdownlist
                                [popupSettings]="{
                                  appendTo: 'component',
                                  popupClass: '.zfix',
                                }"
                                [data]="reminderValues"
                                [formControl]="editForm.controls.reminder"
                                valueField="minutes"
                                textField="text"
                              />
                            }
                          </div>
                        </div>

                        <div class="line"></div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="description-cont">
                          @if (
                            uiState() === 'view' &&
                            dialogData.reservation.bodyHtml !== '' &&
                            dialogData.reservation.bodyHtml?.length > 0
                          ) {
                            <p class="item-label">
                              {{ translation.reservationPopup.description | transloco }}
                            </p>
                            <div [innerHTML]="dialogData.reservation.bodyHtml" class="descriptionText"></div>
                          }
                          @if (uiState() === 'edit') {
                            <p class="item-label">
                              {{ translation.reservationPopup.description | transloco }}
                            </p>
                            <div class="input-group">
                              <ng-container *quillLoad>
                                <quill-editor
                                  cueRtl
                                  defaultEmptyValue=""
                                  [formControl]="$any(editForm.get('bodyHtml'))"
                                  [modules]="modules"
                                  [styles]="{ height: '200px', width: '100%' }"
                                  class="has-clear"
                                  [cueClearable]="true"
                                />
                              </ng-container>
                            </div>
                          }
                          @if (uiState() === 'edit') {
                            <p class="placeholders-info descriptionText">
                              {{ translation.common.placeholders | transloco }}
                            </p>
                          }
                        </div>
                        <div class="line"></div>
                      </div>
                    </div>

                    <!-- navigovat-->
                    @if (showNavigationHint()) {
                      <div class="row">
                        <div class="col-md-12">
                          <p class="item-label">
                            {{ translation.reservationPopup.navigationHint | transloco }}
                          </p>

                          <div class="row">
                            <div class="col-md-6">
                              <assist-dropdownlist
                                [data]="navigationHintValues"
                                [formControl]="editForm.controls.navigationLinkHint"
                                valueField="key"
                                textField="name"
                                [popupSettings]="{
                                  appendTo: 'component',
                                }"
                              />
                            </div>
                          </div>
                          <p class="descriptionText placeholders-info">
                            {{ translation.reservationPopup.navigationHintDescription | transloco }}
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            @if (activeTab() === 1) {
              <assist-reservation-detail-resource-tab
                [eventStart]="start()"
                [resourceAttendees]="dialogData.reservation.resourceAttendees"
              />
            }
            @if (activeTab() === 2) {
              <assist-reservation-detail-orders-tab
                [eventDate]="start()"
                [mode]="mode()"
                [state]="uiState()"
                [reservation]="dialogData.reservation"
                [currentOrders]="currentOrders()"
                (ordersChanged)="setOrdersValue($event)"
                (ordersValidityChanged)="setOrdersValidity($event)"
              />
            }
          </div>
        }
      </div>
    </cue-modal-body>
    <cue-modal-footer>
      @if (uiState() !== 'loading') {
        <cue-button
          data-cy="assist-reservation-detail-close"
          type="secondary"
          [icon]="ICONS.cueClose"
          (click)="closeDialog()"
          [smallResponsive]="true"
        >
          {{ translation.reservationPopup.close | transloco }}
        </cue-button>

        <!-- CONFIRM -->
        @if (dialogData.reservation.showConfirmButton && !isColleague()) {
          <cue-button [icon]="ICONS.cueCheckCircle" (click)="onConfirm()" [smallResponsive]="true">
            {{ translation.dashboard.confirm | transloco }}
          </cue-button>
        }
        <!--          FINISH-->
        @if (!isColleague() && dialogData.reservation.showFinishButton) {
          <cue-button [icon]="ICONS.cueFinish" (click)="onFinish()" [smallResponsive]="true">
            {{ translation.finishEvent.finish | transloco }}
          </cue-button>
        }
        <!--           DELETE -->
        @if (!isColleague() && dialogData.reservation.showDeleteButton) {
          @if (isOccurrenceLikeEvent()) {
            <cue-button
              [icon]="ICONS.cueClose"
              [type]="'delete'"
              (click)="onDeleteOccurrence()"
              [smallResponsive]="true"
            >
              {{ translation.reservationPopup.deleteOccurrence | transloco }}
            </cue-button>
            <cue-button [icon]="ICONS.cueClose" [type]="'delete'" (click)="onDeleteSeries()" [smallResponsive]="true">
              {{ translation.reservationPopup.deleteSeries | transloco }}
            </cue-button>
          } @else if (dialogData.reservation.type === 'seriesMaster') {
            <cue-button [icon]="ICONS.cueClose" [type]="'delete'" (click)="onDeleteSeries()" [smallResponsive]="true">
              {{ translation.reservationPopup.deleteSeries | transloco }}
            </cue-button>
          } @else {
            <cue-button [icon]="ICONS.cueClose" [type]="'delete'" (click)="onDelete()" [smallResponsive]="true">
              {{ translation.dashboard.deleteEvent | transloco }}
            </cue-button>
          }
        }

        @if (
          !dialogData.forceReadonly &&
          !canEditAsNotOrganizer() &&
          !dialogData.reservation.cancelled &&
          dialogData.reservation.meAttending &&
          !dialogData.reservation.isOrganizer &&
          dialogData.reservation &&
          mode() !== 'new'
        ) {
          <cue-button
            [icon]="ICONS.cueDelete"
            [type]="'delete'"
            (click)="cancelParticipation()"
            [smallResponsive]="true"
          >
            {{ translation.dashboard.cancelParticipation | transloco }}
          </cue-button>
        }

        @if (
          canEditAsNotOrganizer() &&
          !dialogData.reservation.cancelled &&
          !dialogData.reservation.isOrganizer &&
          dialogData.reservation &&
          mode() !== 'new'
        ) {
          @if (isOccurrenceLikeEvent()) {
            <cue-button
              [icon]="ICONS.cueDelete"
              [type]="'delete'"
              (click)="onDeleteOccurrence()"
              [smallResponsive]="true"
            >
              {{ translation.reservationPopup.deleteOccurrence | transloco }}
            </cue-button>
            <cue-button [icon]="ICONS.cueDelete" [type]="'delete'" (click)="onDeleteSeries()" [smallResponsive]="true">
              {{ translation.reservationPopup.deleteSeries | transloco }}
            </cue-button>
          } @else if (dialogData.reservation.type === 'seriesMaster') {
            <cue-button [icon]="ICONS.cueDelete" [type]="'delete'" (click)="onDeleteSeries()" [smallResponsive]="true">
              {{ translation.reservationPopup.deleteSeries | transloco }}
            </cue-button>
          } @else {
            <cue-button [icon]="ICONS.cueDelete" [type]="'delete'" (click)="onDelete()" [smallResponsive]="true">
              {{ translation.dashboard.deleteEvent | transloco }}
            </cue-button>
          }
        }
      }
      @if (uiState() === 'view' && isEditable() && (dialogData.reservation.isOrganizer || canEditAsNotOrganizer())) {
        <cue-button [type]="saveButtonType()" [icon]="saveButtonIcon()" (click)="edit()" [smallResponsive]="true">
          {{ saveButtonText() | transloco }}
        </cue-button>
      }

      @if (uiState() === 'edit') {
        <div class="save-button-wrapper">
          @if (availability().disableReasons.length > 0) {
            <ng-template #disableReasonsTemplate>
              @for (reason of availability().disableReasons; track $index) {
                {{ reason.message }}
                <br />
              }
            </ng-template>
            <cue-icon
              class="disable-reason-icon"
              [class.warning]="!hasErrorDisableReason()"
              [icon]="ICONS.cueExclamationCircle"
              cueTooltipCommonType="alert"
              [cueTooltip]="disableReasonsTemplate"
            />
          }
          <cue-button
            data-cy="assist-reservation-detail-save"
            [type]="saveButtonType()"
            [icon]="availability().loading ? ICONS.cueShuffle : saveButtonIcon()"
            [disabled]="
              !dateTimeValid() || availability().loading || (!availability().reservable && !webexPaired().loading)
            "
            [class.loading]="availability().loading"
            (click)="availability().reservable ? save() : 0"
            [smallResponsive]="true"
          >
            {{ saveButtonText() | transloco }}
          </cue-button>
        </div>
      }
    </cue-modal-footer>
  </cue-modal>
}
